import React, { useEffect, useState } from 'react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = localStorage.getItem('urgency_end_time');
    if (saved) {
      const diff = Math.max(0, Math.floor((Number(saved) - Date.now()) / 1000));
      return diff > 0 ? diff : 24 * 60 * 60;
    }
    const endTime = Date.now() + 24 * 60 * 60 * 1000;
    localStorage.setItem('urgency_end_time', String(endTime));
    return 24 * 60 * 60;
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) return 0;
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return <div className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-white py-3 px-4 sticky top-0 z-50 shadow-lg" data-id="element-420">
      <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-421">
        <div className="flex flex-col" data-id="element-422">
          <span className="text-sm md:text-base font-black tracking-wide" data-id="element-423">
            ¡OFERTA EXCLUSIVA!
          </span>
          <span className="text-xs md:text-sm font-semibold text-gray-300" data-id="element-424">
            50% OFF termina en:
          </span>
        </div>

        <div className="flex items-center gap-1 md:gap-2" data-id="element-425">
          <div className="bg-gray-700 rounded-md px-2 md:px-3 py-1 md:py-2 text-center min-w-[40px] md:min-w-[52px]" data-id="element-426">
            <span className="text-lg md:text-2xl font-black tabular-nums" data-id="element-427">
              {pad(hours)}
            </span>
            <p className="text-[8px] md:text-[10px] font-bold text-gray-400 uppercase tracking-wider" data-id="element-428">
              HRS
            </p>
          </div>
          <span className="text-xl md:text-2xl font-black text-gray-500" data-id="element-429">
            :
          </span>
          <div className="bg-gray-700 rounded-md px-2 md:px-3 py-1 md:py-2 text-center min-w-[40px] md:min-w-[52px]" data-id="element-430">
            <span className="text-lg md:text-2xl font-black tabular-nums" data-id="element-431">
              {pad(minutes)}
            </span>
            <p className="text-[8px] md:text-[10px] font-bold text-gray-400 uppercase tracking-wider" data-id="element-432">
              MIN
            </p>
          </div>
          <span className="text-xl md:text-2xl font-black text-gray-500" data-id="element-433">
            :
          </span>
          <div className="bg-gray-700 rounded-md px-2 md:px-3 py-1 md:py-2 text-center min-w-[40px] md:min-w-[52px]" data-id="element-434">
            <span className="text-lg md:text-2xl font-black tabular-nums" data-id="element-435">
              {pad(seconds)}
            </span>
            <p className="text-[8px] md:text-[10px] font-bold text-gray-400 uppercase tracking-wider" data-id="element-436">
              SEG
            </p>
          </div>
        </div>
      </div>
    </div>;
}